<section class="description-section" id="description">
  <!-- title -->
  <h3 class="description-section__title">
    {{ 'global.description' | translate }}
  </h3>
  <!-- content -->
  <div class="description-section__content">
    <p class="product-description">
      {{ productDescription() | translateData }}
    </p>
  </div>
</section>
